import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_WAREHOUSE_MENU } from '@root/core/constants/Warehouse/warehouse-menu';
import ChangePass from '@root/modules/Authentication/ForgotPass/pages/ChangePass';
import MembersPage from '@root/modules/Members/pages/MembersPage';
import SellersPage from '@root/modules/Sellers/Dashboard/pages/SellersPage';
import WarehousePage from '@root/modules/Warehouse/Dasboard/pages/WarehousePage';
import DeliveryHome from '@root/modules/Warehouse/Delivery/pages/DeliveryHome';
import DetailDelivery from '@root/modules/Warehouse/Delivery/pages/DetailDelivery';
import InboundDetailPage from '@root/modules/Warehouse/Inbound/pages/InboundDetail';
import InboundHome from '@root/modules/Warehouse/Inbound/pages/InboundHome';
import InquiryDetailPage from '@root/modules/Warehouse/Inquiry/pages/InquiryDetail';
import InquiryPage from '@root/modules/Warehouse/Inquiry/pages/InquiryPage';
import InventoryDetail from '@root/modules/Warehouse/Inventory/pages/InventoryDetail';
import InventoryHome from '@root/modules/Warehouse/Inventory/pages/InventoryHome';
import InventSellName from '@root/modules/Warehouse/Inventory/pages/InventSellName';
import Paypal from '@root/modules/Warehouse/MyPage/components/Paypal';
import HomeWarehouse from '@root/modules/Warehouse/MyPage/pages/HomeWarehouse';
import ReturnPage from '@root/modules/Warehouse/Return/pages/ReturnPage';
import ReturnPageDetail from '@root/modules/Warehouse/Return/pages/ReturnPageDetail';
import BillingInquiryDetailPage from '@root/modules/Warehouse/Settlement/BillingInquiry/pages/BillingInquiryDetailPage';
import BillingInquiryPage from '@root/modules/Warehouse/Settlement/BillingInquiry/pages/BillingInquiryPage';
import CreateBilling from '@root/modules/Warehouse/Settlement/BillingInquiry/pages/CreateBilling';
import ServiceInquiryDetailPage from '@root/modules/Warehouse/Settlement/ServiceInquiry/pages/ServiceInquiryDetailPage';
import ServiceInquiryPage from '@root/modules/Warehouse/Settlement/ServiceInquiry/pages/ServiceInquiryPage';
import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import ReturnDelivery from '@modules/Warehouse/Delivery/pages/ReturnDelivery';
import ReturnDeliveryDetail from '@modules/Warehouse/Delivery/pages/ReturnDeliveryDetail';
import UpdateDelivery from '@modules/Warehouse/Delivery/pages/UpdateDelivery';
import DeliveryCsv from '@modules/Warehouse/Delivery/pages/DeliveryCsv';

const { Sider, Content } = Layout;

interface Props {
  path?: string;
}

const WarehouseSidebar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [listInquiry, setListInquiry] = useState([] as any);
  const [selected, setSeclected] = useState('');
  const [active, setActive] = useState(false);
  const location = useLocation();
  const [a, setA] = useState([] as any);

  const activeItem = (event: any) => {
    setSeclected(event.key);
  };

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);

  const renderAdminOrStoreHeader = () => {
    return (
      <>
        <Layout className="navigation">
          <Sider collapsedWidth="48" width="230" className="side-bar__menu">
            <Menu
              mode="inline"
              style={{ height: '100%', borderRight: 0 }}
              selectedKeys={[path]}
            >
              {ADMIN_WAREHOUSE_MENU.map((item: any, index: number) => (
                <>
                  {item.children ? (
                    <>
                      <Menu.SubMenu
                        title={item.label}
                        key={index}
                        style={{
                          color: '#636363',
                          fontWeight: '200'
                        }}
                      >
                        {item.children.map((child: any, idx: number) => (
                          <>
                            <Menu.Item
                              key={idx}
                              className={active ? 'active' : ''}
                            >
                              <Link
                                to={child.url}
                                style={{
                                  color:
                                    selected ===
                                    `tmp
                                _key-${index}`
                                      ? '#0077ff'
                                      : '',
                                  fontWeight:
                                    a[0] === child.url.replace('/admin/', '')
                                      ? 'bold'
                                      : '200'
                                }}
                              >
                                {t(child.name)}
                              </Link>
                            </Menu.Item>
                          </>
                        ))}
                      </Menu.SubMenu>
                    </>
                  ) : (
                    <Menu.Item
                      // className={"menu-nav"}
                      title={item.label}
                      onClick={(event) => activeItem(event)}
                      className={active ? 'active' : ''}
                      key={index}
                    >
                      <Link
                        key={item.id}
                        to={item.url}
                        style={{
                          color:
                            selected ===
                            `tmp
                        _key-${index}`
                              ? '#0077ff'
                              : '',
                          fontWeight:
                            !!a[0] && a[0] == item.url.replace('/admin/', '')
                              ? 'bold'
                              : !!a[0] &&
                                a[0]
                                  .replace('/admin/', '')
                                  .split('-')
                                  .includes(item.url.replace('/admin/', ''))
                              ? 'bold'
                              : '200'

                          // !a[1] && item.url == '/admin/warehouse'
                          //   ? 'bold'
                          //   : a[1] ==
                          //       item.url.replace('/admin/seller/', '') ||
                          //     (!!a[2] &&
                          //       a[1] == 'stock-detail' &&
                          //       item.url.replace('/admin/seller/', '') ==
                          //         'stock')
                          //   ? 'bold'
                          //   : '500'
                        }}
                      >
                        {t(item.name)}
                      </Link>
                    </Menu.Item>
                  )}
                </>
              ))}
            </Menu>
          </Sider>
          <Layout>
            <Content
              style={{
                minHeight: 280,
                minWidth: 1080,
                overflow: 'scroll'
              }}
            >
              <Switch>
                <Route path="/admin/reset-password/:token">
                  <ChangePass />
                </Route>
                <Route exact path="/admin/warehouse">
                  <WarehousePage />
                </Route>
                <Route path="/admin/sellers/dashboard">
                  <SellersPage />
                </Route>
                {/* Inbound */}
                <Route exact path="/admin/inbound">
                  <InboundHome />
                </Route>
                <Route path="/admin/inbound/:id">
                  <InboundDetailPage />
                </Route>
                {/* Inventory */}
                <Route exact path="/admin/inventory">
                  <InventoryHome />
                </Route>
                <Route path="/admin/inventory/:idSellName">
                  <InventSellName />
                </Route>
                <Route path="/admin/inventory-details/:inventoryId/product/:productId">
                  <InventoryDetail />
                </Route>
                {/* Delivery */}{' '}
                <Route exact path="/admin/delivery">
                  <DeliveryHome />
                </Route>
                <Route path="/admin/delivery/csv">
                  <DeliveryCsv />
                </Route>
                <Route exact path="/admin/delivery/edit/:idDelivery/:commentId">
                  <UpdateDelivery />
                </Route>
                <Route path="/admin/delivery/:idDelivery">
                  <DetailDelivery />
                </Route>
                <Route exact path="/admin/returnDelivery">
                  <ReturnDelivery />
                </Route>
                <Route exact path="/admin/returnDelivery/:id">
                  <ReturnDeliveryDetail />
                </Route>
                {/* Inquiry */}
                <Route exact path="/admin/inquiry">
                  <InquiryPage
                    listInquiry={listInquiry}
                    setListInquiry={setListInquiry}
                  />
                </Route>
                <Route path="/admin/inquiry/:id">
                  <InquiryDetailPage listInquiry={listInquiry} />
                </Route>
                <Route path="/admin/members">
                  <MembersPage />
                </Route>
                <Route exact path="/admin/return">
                  <ReturnPage />
                </Route>
                <Route exact path="/admin/return/:id">
                  <ReturnPageDetail />
                </Route>
                <Route exact path="/admin/billingInquiry">
                  <BillingInquiryPage />
                </Route>
                <Route path="/admin/billingInquiry/create-inquiry">
                  <CreateBilling />
                </Route>
                <Route
                  exact
                  path="/admin/billingInquiry/billingInquiryDetail/:id"
                >
                  <BillingInquiryDetailPage />
                </Route>
                <Route exact path="/admin/serviceInquiry">
                  <ServiceInquiryPage />
                </Route>
                <Route
                  exact
                  path="/admin/serviceInquiry/serviceInquiryDetail/:id"
                >
                  <ServiceInquiryDetailPage />
                </Route>
                <Route path="/admin/seller/page-warehouse">
                  <HomeWarehouse />
                </Route>
                <Route path="">
                  <Redirect to="/admin/warehouse" />
                </Route>
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(WarehouseSidebar);
